import { useState, useEffect, useRef } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../api/api";
import { KONTAKT } from "../config/kontakt";

const KEY = "impressum_html";

function StaticContent() {
  const h3 = { color: "#2e7d32", margin: "1.5rem 0 0.5rem" };
  const tdL = { paddingRight: "1.5rem", paddingBottom: "0.4rem", whiteSpace: "nowrap", verticalAlign: "top", color: "#333", fontWeight: 600 };
  const tdR = { paddingBottom: "0.4rem" };
  return (
    <>
      <h3 style={h3}>Daten nach dem Telemediengesetz</h3>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.95rem" }}>
        <tbody>
          <tr><td style={tdL}>Betreiber der Seite:</td><td style={tdR}>Erich Gehrke</td></tr>
          <tr><td style={tdL}>Gesellschafter:</td><td style={tdR}>{KONTAKT.name}, {KONTAKT.strasse}, {KONTAKT.ort}</td></tr>
          <tr>
            <td style={tdL}>Anschrift und Kontakt:</td>
            <td style={tdR}>
              {KONTAKT.betrieb}<br />{KONTAKT.strasse}<br />{KONTAKT.ort}<br />
              Tel. {KONTAKT.telefon}<br />Fax. {KONTAKT.fax}<br />E-Mail: {KONTAKT.emailObfusk}
            </td>
          </tr>
        </tbody>
      </table>

      <h3 style={h3}>EU-Streitschlichtung</h3>
      <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer" style={{ color: "#2e7d32" }}>
          https://ec.europa.eu/consumers/odr
        </a>
      </p>

      <h3 style={h3}>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h3>
      <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

      <h3 style={h3}>Haftung für Inhalte</h3>
      <p>Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
      <p>Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>

      <h3 style={h3}>Haftung für Links</h3>
      <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p>
      <p>Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>

      <h3 style={h3}>Urheberrecht</h3>
      <p>Alle Fotos sind Eigentum vom Milchhof Gehrke.</p>
      <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.</p>
      <p>Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>
    </>
  );
}

export default function Impressum() {
  const { user } = useAuth();
  const isAdmin = !!user?.isAdmin;
  const cardRef = useRef(null);
  const [savedHtml, setSavedHtml] = useState(null);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState("");
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    api.einstellungen.get(KEY).then(r => { if (r) setSavedHtml(r); }).catch(() => {});
  }, []);

  function startEdit() {
    setDraft(savedHtml ?? cardRef.current?.innerHTML ?? "");
    setEditing(true);
    setMsg(null);
  }

  async function save() {
    try {
      await api.einstellungen.update(KEY, draft);
      setSavedHtml(draft);
      setEditing(false);
      setMsg("✓ Gespeichert!");
      setTimeout(() => setMsg(null), 3000);
    } catch { setMsg("Fehler beim Speichern."); }
  }

  async function reset() {
    if (!window.confirm("Wirklich auf Standard zurücksetzen?")) return;
    try {
      await api.einstellungen.update(KEY, "");
      setSavedHtml(null);
      setEditing(false);
    } catch { setMsg("Fehler."); }
  }

  return (
    <div className="container" style={{ maxWidth: 800 }}>
      <h2 className="section-title" style={{ marginTop: "1rem" }}>Impressum</h2>
      {msg && <p style={{ color: msg.startsWith("✓") ? "green" : "red", margin: "0.5rem 0" }}>{msg}</p>}

      {editing ? (
        <div className="card" style={{ marginTop: "1.5rem" }}>
          <p style={{ color: "#888", fontSize: "0.82rem", marginBottom: "0.5rem" }}>
            Du bearbeitest den Seiteninhalt als HTML. Überschriften: &lt;h3&gt;...&lt;/h3&gt;, Absätze: &lt;p&gt;...&lt;/p&gt;
          </p>
          <textarea
            value={draft}
            onChange={e => setDraft(e.target.value)}
            rows={30}
            style={{ width: "100%", fontFamily: "monospace", fontSize: "0.85rem", padding: "0.5rem", borderRadius: 6, border: "1px solid #ccc", resize: "vertical" }}
          />
          <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.75rem", flexWrap: "wrap" }}>
            <button className="btn btn-primary" onClick={save}>💾 Speichern</button>
            <button className="btn btn-secondary" onClick={() => setEditing(false)}>Abbrechen</button>
            {savedHtml && <button className="btn btn-secondary" style={{ marginLeft: "auto", color: "#c62828" }} onClick={reset}>↺ Auf Standard zurücksetzen</button>}
          </div>
        </div>
      ) : (
        <div className="card" style={{ marginTop: "1.5rem", lineHeight: "1.9", color: "#555" }}>
          <div ref={cardRef}>
            {savedHtml
              ? <div dangerouslySetInnerHTML={{ __html: savedHtml }} />
              : <StaticContent />
            }
          </div>
          {isAdmin && (
            <button className="btn btn-secondary" style={{ marginTop: "1.5rem" }} onClick={startEdit}>
              ✏️ Impressum bearbeiten
            </button>
          )}
        </div>
      )}
    </div>
  );
}
